// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.text[data-v-70e483c4] {\n\tfont-size: 14px;\n}\n.value[data-v-70e483c4] {\n\tfont-size: 12px;\n\tcolor: var(--main-gray-5);\n}\n.selected .value[data-v-70e483c4] {\n\tcolor: var(--main-gray-1);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
